/** Lightweight suite catalog for ecosystem chrome (mirrors @unity-cosmos/suite). */
import { ORBIT_APPS, SUITE_APPS } from '@unity-cosmos/suite'

/** Hub-only chrome theme (not listed in worlds menu). */
export const HUB_CHROME = {
  id: 'hub',
  shortName: 'Unity Cosmos',
  accent: '#0099ff',
  mark: 'UC',
  theme: {
    mode: 'dark',
    bg: '#000000',
    line: 'rgba(232, 236, 242, 0.08)',
    ink: '#eceef2',
    muted: 'rgba(138, 145, 158, 0.95)',
    surface: 'rgba(0, 0, 0, 0.42)',
    surfaceBorder: 'rgba(232, 236, 242, 0.12)',
    ctaInk: '#040a14',
    cosmos: '#33ccff',
  },
}

export const UNITY_SUITE = SUITE_APPS.map((app) => ({
  id: app.id,
  name: app.name,
  shortName: app.shortName,
  href: app.href ?? '',
  status: app.status,
  accent: app.accent,
  theme: app.theme,
  embedTheme: app.embedTheme,
}))

export const UNITY_HUB = 'https://unitycosmos.com'
export const UNITY_DASHBOARD = 'https://unitycosmos.com/dashboard'
